import { css } from '@emotion/react';
import {
  type FC, type PropsWithChildren,
} from 'react';

const shapeStyle = ({ colors, size, shape }: { size: number; colors: ColorProps; shape: Shape }) => css({
  alignItems: 'center',
  background: colors.fillColor,
  borderRadius: shape === Shape.circle ? '50%' : '4px',
  color: colors.fontColor,
  cursor: 'default',
  display: 'inline-flex',
  flexShrink: 0,
  height: size,
  justifyContent: 'center',
  lineHeight: `${size}px`,
  width: size,
});

export enum Shape {
  circle = 'circle',
  square = 'square',
}

type ColorProps = Readonly<{
  fontColor: string;
  fillColor: string;
}>;

export type SharedNumberProps = PropsWithChildren<{
  className?: string;
  colors: ColorProps;
  size: number;
}>;

export type NumberInShapeProps = SharedNumberProps & Readonly<{ shape: Shape}>;

export const NumberInShapeComponent: FC<NumberInShapeProps> = props => {
  return (
    <div
      className={props.className}
      css={shapeStyle({ colors: props.colors, size: props.size, shape: props.shape })}
    >
      {props.children}
    </div>
  );
};
